import { render, staticRenderFns } from "./timezone.vue?vue&type=template&id=818ff684&"
import script from "./timezone.vue?vue&type=script&lang=ts&"
export * from "./timezone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports